const turkishCharacterRegex = keyword => keyword
.replace(/[ıİiI]/g, '[ıİiI]')
.replace(/[şŞsS]/g, '[şŞsS]')
.replace(/[çÇcC]/g, '[çÇcC]')
.replace(/[ğĞgG]/g, '[ğĞgG]')
.replace(/[öÖoO]/g, '[öÖoO]')
.replace(/[üÜuU]/g, '[üÜuU]');

export const customFilterTool = (option, searchText) =>((turkishCharacterRegex(option.data.label)).toLowerCase().includes(turkishCharacterRegex(searchText).toLowerCase()));
